import React from 'react';
import Typography from '@mui/material/Typography'
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
} from '@mui/material'
import Cancel from './../../../../assets/icons/close.png'
import arrowUp from './../../../../assets/icons/arrowup.png'
import arrowDown from './../../../../assets/icons/arrowDown.png'
import axios from 'axios';

function SectionItemsDialog(props) {
    const handleClose = () => {
        props.onHandleAddItem(false)
    }
    const [selectedItems, setSelectedItems] = React.useState([]);
    const apiAddress = process.env.REACT_APP_SECRET;
    React.useEffect(() => {
        console.log(props.dialogType);
        setSelectedItems([]);
        // let val = ItemDatas.filter(x => x.section == props.dialogType);
        // console.log(val);

        axios.get(apiAddress + "/api/Section/getallfooditembysectionid?sectionId=" + props.dialogType + "&fromtype=" + props.type)
            .then((response) => {
                console.log(response.data);
                setSelectedItems(response.data)
            })
            .catch((error) => {
                console.log(error);
            })


    }, [props.dialogType])

    return (
        <div>
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth={'lg'}
                    open={props.open}
                    onClose={handleClose}
                >
                    <Grid container>
                        <Grid item xs={6}>
                            <DialogTitle>
                                <span style={{ color: "#2a7fd4" }}>GoTaste :- Food Item For {props.sectionName} section</span>
                            </DialogTitle>
                        </Grid>
                        <Grid item xs={6}>
                            <DialogActions>
                                <Button onClick={handleClose}>
                                    <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
                        <table className='table'>
                            <thead>
                                <tr>
                                    {/* <th>
                                        Display order
                                    </th> */}
                                    <th>
                                        Item Name
                                    </th>
                                    <th>
                                        Menu
                                    </th>
                                    <th>
                                        Restaurant
                                    </th>
                                    <th>
                                        Price
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedItems.map((data, index) => {
                                    return (
                                        <tr>
                                            {/* <td>
                                                <div className='d-flex' style={{ width: "4rem", gap: "10px" }}>
                                                    <span><img src={arrowUp} style={{ width: "1rem" }} /></span>
                                                    <input type='number' className='form-control' style={{ width: "7rem" }} defaultValue={data.rank} />
                                                    <span><img src={arrowDown} style={{ width: "1rem" }} /></span>
                                                </div>

                                            </td> */}
                                            <td>
                                                {data.title}
                                            </td>
                                            <td>
                                                {data.menu}
                                            </td>
                                            <td>
                                                {data.restaurantName}
                                            </td>
                                            <td>
                                                {data.price}
                                            </td>

                                        </tr>
                                    )

                                })}
                            </tbody>
                        </table>

                    </DialogContent>
                    {/* <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions> */}
                </Dialog>
            </React.Fragment>
        </div>
    );
}

export default SectionItemsDialog;